import HttpService from "./http.service";
import { getAccessToken, getRefreshToken, refreshAccessToken } from "./authTokens";

// Requests that must not trigger a silent refresh when they answer 401
const NO_REFRESH_URLS = ["login", "refresh", "logout"];

let onUnauthenticatedHandler = () => {};
let installed = false;

export const setupAxiosInterceptors = (onUnauthenticated) => {
  // App calls this on every render; keep the latest callback but install once
  onUnauthenticatedHandler = onUnauthenticated;
  if (installed) return;
  installed = true;

  const onRequestSuccess = async (config) => {
    const token = getAccessToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  };
  const onRequestFail = (error) => Promise.reject(error);

  HttpService.addRequestInterceptor(onRequestSuccess, onRequestFail);

  const onResponseSuccess = (response) => response;

  const onResponseFail = async (error) => {
    const status = error.status || error.response?.status;
    const config = error.config;

    // Access token expired: trade the refresh token for a new pair and replay once
    if (
      status === 401 &&
      config &&
      !config._retriedAfterRefresh &&
      !NO_REFRESH_URLS.includes(config.url) &&
      getRefreshToken()
    ) {
      config._retriedAfterRefresh = true;
      try {
        const accessToken = await refreshAccessToken();
        config.headers.Authorization = `Bearer ${accessToken}`;
        return HttpService._axios.request(config);
      } catch (refreshError) {
        onUnauthenticatedHandler();
        return Promise.reject(error);
      }
    }

    if (status === 403 || status === 401) {
      // A 403 can mean "signed in, but this account lacks the grant" rather
      // than an expired session. Callers that must keep the current screen
      // (for example the calibration save, which reports its own permission
      // failure and retry) opt out with skipLogoutOn403.
      const handledByCaller = status === 403 && config?.skipLogoutOn403;
      if (!handledByCaller) onUnauthenticatedHandler();
    }

    return Promise.reject(error);
  };
  HttpService.addResponseInterceptor(onResponseSuccess, onResponseFail);
};
